
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    visible: Boolean,
  },

  emits: ['click'],

  methods: {
    onPwdEyeClick() {
      this.$emit('click');
    },
  },
});
